import React from 'react';
import { ChartNode } from 'react-flame-graph';
import FooterDelete from './FooterDelete';
import FooterPlus from './FooterPlus';
import './FooterNode.css';
import { DisplayNode, NullableDepLink } from '../../types';

type Props = {
  focusedNode?: DisplayNode | ChartNode;
  focusedNodeId?: string;
  nodeChildren: string[];
  nodeParents: string[];
  shortenName: (s?: string) => string;
  focusNode: (id: string) => void;
  removeLink: (id: NullableDepLink) => void;
  addLink: (id: NullableDepLink) => void;
};

type State = {
  addChildInput: string;
};

class FooterNode extends React.Component<Props, State> {
  state: State = {
    addChildInput: 'New child...',
  };

  render() {
    const {
      focusedNode,
      focusedNodeId,
      nodeChildren,
      nodeParents,
      shortenName,
      focusNode,
      removeLink,
      addLink,
    } = this.props;

    const { addChildInput } = this.state;

    return (
      <div className="footer-node">
        <div className="footer__title">Name:</div>
        <div>{shortenName(focusedNode?.name)}</div>
        {nodeParents.length ? <div className="footer__title">Parents:</div> : null}
        {nodeParents.map((parent) => (
          <div className="footer__pill" key={parent}>
            <span
              className="footer--clickable"
              onClick={() => focusNode(parent)}
              onKeyPress={() => focusNode(parent)}
              role="button"
              tabIndex={0}
            >
              {shortenName(parent)}
            </span>
            <FooterDelete
              className="footer--clickable"
              onClick={() =>
                removeLink({
                  parent,
                  child: focusedNodeId,
                })
              }
            />
          </div>
        ))}
        <div className="footer__title">Children:</div>
        {nodeChildren.map((child) => (
          <div className="footer__pill" key={child}>
            <span
              className="footer--clickable"
              onClick={() => focusNode(child)}
              onKeyPress={() => focusNode(child)}
              role="button"
              tabIndex={0}
            >
              {shortenName(child)}
            </span>
            <FooterDelete
              className="footer--clickable"
              onClick={() =>
                removeLink({
                  parent: focusedNodeId,
                  child,
                })
              }
            />
          </div>
        ))}
        <div className="footer__pill">
          <input
            className="footer-node__input"
            value={addChildInput}
            type="text"
            onChange={(event) =>
              this.setState({
                addChildInput: event.target.value,
              })
            }
          />
          <FooterPlus
            className="footer--clickable"
            onClick={() =>
              addLink({
                parent: focusedNodeId,
                child: addChildInput,
              })
            }
          />
        </div>
      </div>
    );
  }
}

export default FooterNode;
